<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Evaluadores"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            <i data-feather="plus" class="pr-2" />Nuevo Evaluador
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <evaluator-modal
      v-if="isAddEditModalActive"
      modalTitle="Añadir Evaluador"
      editModalTitle="Editar Evaluador"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <dashboard-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiURL";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "evaluator-table",
      rowData: {},
      options: {
        name: "",
        url: `${actions.EVALUATOR_MAINTENANCE}/index`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "evaluator-modal",
            modalId: "modal-add-edit",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "modal-delete",
          },
          {
            title: this.$t("Configurar evaluador"),
            icon: "settings",
            type: "none",
            component: "evaluator-config",
          },
        ],
        filters: [
          {
            title: "Funcion",
            type: "drop-down-filter",
            key: "evaluator_type",
            option: this.evaluatorType,
          },
          {
            title: "Ambito",
            type: "checkbox",
            key: "scope",
            option: [
              {
                id: "O",
                value: "SAE",
              },
              {
                id: "E",
                value: "Externo",
              },
            ],
          },
          {
            title: "Tipo de Institucion",
            type: "checkbox",
            key: "type_institution",
            option: [
              {
                id: "PU",
                value: "Publica",
              },
              {
                id: "PR",
                value: "Privada",
              },
            ],
          },
          {
            title: "Estado",
            type: "checkbox",
            key: "is_active",
            option: [
              {
                id: 2,
                value: "NO",
              },
              {
                id: 1,
                value: "SI",
              },
            ],
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  watch: {
    "$store.state.evaluatorReview.evaluatorType": function () {
      const tmp = this.options.filters.find(
        (element) => element.key === "evaluator_type"
      );
      tmp.option = this.$store.state.evaluatorReview.evaluatorType;
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#modal-add-edit").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("Configurar evaluador")) {
        localStorage.setItem('evaluator_id', rowData.id)
        this.selectedUrl = `${actions.EVALUATOR_MAINTENANCE}/config/${rowData.id}`;
        window.location = this.selectedUrl;
      }
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      }
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.EVALUATOR_MAINTENANCE}/${rowData.id}`;
        this.openAddEditModal();
      }
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.EVALUATOR_MAINTENANCE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#modal-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    data() {
      this.$store.dispatch("getAccAppOptions");
      this.$store.dispatch("getPoliticalDivision");
      this.$store.dispatch("getEvaluatorType");
    },
  },
};
</script>
